module.exports = {

    methods: {

        /**
         * Fetch all roles
         */
        fetchRoles(){
            axios.get('/management/roles').then(response => {
                App.bus.$emit('roles-fetched', response.data)
            })
        },
    }
}
